import styled from 'styled-components';

export const BackgroundWrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;

	position: relative;
	&::before {
		content: '';
		display: block;
		width: 16px;
		height: 100%;
		background-color: ${({ theme }) => theme.colors.gray.gray15};

		position: absolute;
		top: 0;
		left: 0;
		/* top: 88px;
		left: 80px; */
		z-index: 11;
	}
	&::after {
		content: '';
		display: block;
		width: 16px;
		height: 100%;
		background-color: ${({ theme }) => theme.colors.gray.gray15};

		position: absolute;
		top: 0;
		right: 0px;
		/* top: 88px;
		right: 0px; */
		z-index: 11;
	}
`;

export const Background = styled.div`
	width: 100%;
	height: 100%;
	padding: 16px;
	background-color: ${({ theme }) => theme.colors.gray.gray15};

	overflow: overlay;
	${({ theme }) => theme.common.scroll};
`;

export const Section = styled.div<{ is_hover?: boolean }>`
	width: 100%;
	height: auto;
	min-height: 100%;
	border-radius: 16px;
	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};

	overflow-x: overlay;
	overflow-y: hidden;
	${({ theme, is_hover }) => theme.common.scrollToggle(is_hover ? true : false)};
`;

export const SectionHeaderRow = styled.div<{ _padding?: string; radius?: string }>`
	width: 100%;
	height: auto;
	${({ _padding }) => _padding && `padding: ${_padding}`};
	${({ radius }) => radius && `border-radius: ${radius}`};
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray15};

	position: sticky;
	left: 0;
	z-index: 5;
`;

export const StickySectionHeaderRow = styled(SectionHeaderRow)<{
	sticky_top?: string;
	sticky_left?: string;
	z_index?: number;
}>`
	position: sticky;
	top: ${({ sticky_top }) => sticky_top ?? `top: 0px`};
	/* ${({ sticky_left }) => sticky_left ?? `top: 0px`}; */
	z-index: ${({ z_index }) => (z_index !== undefined ? z_index : 10)};

	transition: 0.2s border-radius;
`;
